import { apiRequest } from "../lib/apiClient";
import type { TaxRateCreate, TaxRateOut, TaxRateUpdate } from "./types";

/** `GET /tax-rates` — any authenticated user. */
export async function listTaxRates(
  accessToken: string,
  filters: { branchId?: string; activeOnly?: boolean } = {},
): Promise<TaxRateOut[]> {
  return apiRequest<TaxRateOut[]>("/tax-rates", {
    accessToken,
    query: { branch_id: filters.branchId, active_only: filters.activeOnly },
  });
}

/** `POST /tax-rates` — OWNER/ACCOUNTANT only. */
export async function createTaxRate(accessToken: string, body: TaxRateCreate): Promise<TaxRateOut> {
  return apiRequest<TaxRateOut>("/tax-rates", { method: "POST", accessToken, body });
}

/** `PATCH /tax-rates/{id}` — OWNER/ACCOUNTANT only. Partial update (only set fields change). */
export async function updateTaxRate(accessToken: string, taxRateId: string, body: TaxRateUpdate): Promise<TaxRateOut> {
  return apiRequest<TaxRateOut>(`/tax-rates/${taxRateId}`, { method: "PATCH", accessToken, body });
}

/** `DELETE /tax-rates/{id}` — OWNER/ACCOUNTANT only. Soft delete only. */
export async function deleteTaxRate(accessToken: string, taxRateId: string): Promise<void> {
  await apiRequest<void>(`/tax-rates/${taxRateId}`, { method: "DELETE", accessToken });
}
